import React from 'react';
import { Box, Typography, Card, CardActionArea, CardContent } from '@mui/material';
import {
  LocalHospital as HospitalIcon,
  Group as GroupIcon,
  Assignment as AssignmentIcon,
  Settings as SettingsIcon,
  BugReport as BugReportIcon,
  People as PeopleIcon,
  MedicalServices as MedicalServicesIcon,
  InfoOutlined as InfoIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const AdminConfiguracion: React.FC = () => {
  const navigate = useNavigate();
  const env = process.env.REACT_APP_ENV || (window as any).REACT_APP_ENV;
  const isDev = env === 'dev';
  const { t } = useTranslation();

  const actions = [
    { label: t('adminConfig.hospitals'), path: '/dashboard/hospitals', icon: <HospitalIcon sx={{ fontSize: 40 }} /> },
    { label: t('adminConfig.societies'), path: '/dashboard/sociedades', icon: <GroupIcon sx={{ fontSize: 40 }} /> },
    { label: t('adminConfig.residentProgram'), path: '/dashboard/fases', icon: <AssignmentIcon sx={{ fontSize: 40 }} /> },
    { label: t('adminConfig.societiesProgram'), path: '/dashboard/fases-soc', icon: <AssignmentIcon sx={{ fontSize: 40 }} /> },
    { label: t('adminConfig.users'), path: '/dashboard/usuarios', icon: <PeopleIcon sx={{ fontSize: 40 }} /> },
    { label: t('adminConfig.accessCodes'), path: '/dashboard/access-codes', icon: <SettingsIcon sx={{ fontSize: 40 }} /> },
    { label: t('adminConfig.surgeryTypes'), path: '/dashboard/cirugias', icon: <MedicalServicesIcon sx={{ fontSize: 40 }} /> },
    { label: t('adminConfig.siteInfo'), path: '/dashboard/site-info', icon: <InfoIcon sx={{ fontSize: 40 }} /> },
    ...(isDev ? [{ label: t('adminConfig.debug'), path: '/dashboard/debug', icon: <BugReportIcon sx={{ fontSize: 40 }} /> }] : [])
  ];

  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        {t('adminConfig.title')}
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
        {actions.map(action => (
          <Box key={action.label} sx={{ width: { xs: '100%', sm: '48%', md: '31%', lg: '23%' } }}>
            <Card>
              <CardActionArea onClick={() => navigate(action.path)}>
                <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 4 }}>
                  {action.icon}
                  <Typography variant="subtitle1" sx={{ mt: 1, textAlign: 'center' }}>
                    {action.label}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default AdminConfiguracion;
